export default __webpack_public_path__ + "static/media/rug16-min.b56be57e.jpg";